import { useUserStore } from "../store/user";

const updatePermissionDisplay = (el, binding) => {
  const userStore = useUserStore();
  const visible = userStore.hasPermission(binding.value);

  el.style.display = visible ? "" : "none";
};

export default {
  mounted: updatePermissionDisplay,
  updated: updatePermissionDisplay,
};
